const LANGUAGE_KEY = "jcl-ui-language";

export function uiLocale() {
  if (typeof window === "undefined") return "en-GB";
  const stored = window.localStorage.getItem(LANGUAGE_KEY);
  if (stored === "zh" || stored === "zh-CN") return "zh-CN";
  if (stored === "zh-TW") return "zh-TW";
  return "en-GB";
}

export function number(value, digits = 0) {
  return new Intl.NumberFormat(uiLocale(), {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(Number(value || 0));
}

export function percent(value, digits = 1) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return "—";
  return `${Number(value).toFixed(digits)}%`;
}

export function date(value) {
  if (!value) return "—";
  return new Intl.DateTimeFormat(uiLocale(), {
    year: "numeric",
    month: "short",
    day: "2-digit",
  }).format(new Date(value));
}

export function dateTime(value) {
  if (!value) return "—";
  return new Intl.DateTimeFormat(uiLocale(), {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(value));
}

export function relativeDate(value) {
  if (!value) {
    const locale = uiLocale();
    if (locale === "zh-TW") return "尚無活動";
    if (locale === "zh-CN") return "暂无活动";
    return "No activity yet";
  }

  const delta = Date.now() - new Date(value).getTime();
  const minutes = Math.floor(delta / 60000);
  const locale = uiLocale();

  if (locale === "zh-TW") {
    if (minutes < 1) return "剛剛";
    if (minutes < 60) return `${minutes} 分鐘前`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours} 小時前`;
    const days = Math.floor(hours / 24);
    return `${days} 天前`;
  }

  if (locale === "zh-CN") {
    if (minutes < 1) return "刚刚";
    if (minutes < 60) return `${minutes} 分钟前`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours} 小时前`;
    const days = Math.floor(hours / 24);
    return `${days} 天前`;
  }

  if (minutes < 1) return "just now";
  if (minutes < 60) return `${minutes} min ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} hr ago`;
  const days = Math.floor(hours / 24);
  return `${days} day${days === 1 ? "" : "s"} ago`;
}

export function safeUrl(value) {
  const text = String(value || "").trim();
  if (!text) return "";
  return /^https?:\/\//i.test(text) ? text : `https://${text}`;
}

export function downloadCsv(filename, rows) {
  if (!rows?.length) return;
  const headers = Array.from(new Set(rows.flatMap((row) => Object.keys(row))));
  const quote = (value) => `"${String(value ?? "").replaceAll('"', '""')}"`;
  const csv = [headers.map(quote).join(","), ...rows.map((row) => headers.map((header) => quote(row[header])).join(","))].join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}
